import React from 'react'

const VerticalFlipIcon = ({color = 'currentColor', width = 24, height = 24, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M3 15V17H5V15H3ZM15 19V21H17V19H15ZM19 3L5 3C3.9 3 3 3.9 3 5V9H5V5L19 5V9H21V5C21 3.9 20.1 3 19 3ZM21 19H19V21C20.1 21 21 20.1 21 19ZM1 11L1 13L23 13L23 11L1 11ZM7 19V21H9V19L7 19ZM19 15L19 17H21V15H19ZM11 19V21H13V19H11ZM3 19C3 20.1 3.9 21 5 21V19H3Z"
            fill={color}
        />
    </svg>
)

export default VerticalFlipIcon
